import { useTranslation } from 'react-i18next';
import { ButtonLoader } from './ButtonLoader';
import Img from './Img';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useAuth } from 'react-oidc-context';
import { dataLayerPush } from '@Services/ga4';
import { GA4Events } from '@Services/ga4Events';
import { FLOWS, STEPS, ErrorsTypes } from '@models/enums/ga4.enum';
import TameeniLoader from './TameeniLoader';

export default function SessionExpirePopup() {
  const { t } = useTranslation(['translation']);
  const [domReady, setDomReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [hidePopup, setHidePopup] = useState(false);
  const auth = useAuth();

  useEffect(() => {
    setDomReady(true);
  }, []);

  const handleConfirm = async () => {
    setIsLoading(true);
    setShowLoader(true);
    sessionStorage.setItem('skipGTM', 'true');
    // Log error event to GTM
    dataLayerPush(GA4Events.errorCaptured.event, [
      {
        key: GA4Events.errorCaptured.params.flowName,
        value: FLOWS.MOTOR,
      },
      {
        key: GA4Events.errorCaptured.params.stepName,
        value: STEPS.SESSION_ERROR,
      },
      {
        key: GA4Events.errorCaptured.params.errorCode,
        value: '401',
      },
      {
        key: GA4Events.errorCaptured.params.errorMessage,
        value: 'Session expired or invalid',
      },
      {
        key: GA4Events.errorCaptured.params.type,
        value: ErrorsTypes.REQUEST,
      },
    ]);

    try {
      // Logout from backend without disrupting the journey
      await auth.signoutSilent();

      // Clear storage
      localStorage.clear();
      localStorage.removeItem('token');
      sessionStorage.removeItem('skipGTM');

      // Show loader with message for a moment
      setTimeout(() => {
        // Open login popup
        const loginTrigger = document.getElementById('Login-popup-trigger');
        if (loginTrigger) {
          loginTrigger.click();
        }
        setHidePopup(true);
        setShowLoader(false);
        setIsLoading(false);
      }, 2000); // Show loader for 2 seconds
    } catch (error) {
      setShowLoader(false);
      setIsLoading(false);

      // Fallback: redirect to home page
      window.parent.location.href = '/';
    }
  };

  if (showLoader) return <TameeniLoader />;

  const element = (
    <div
      className={`modal w-full ${hidePopup ? 'hidden' : ''}`}
      id='Sesssion-expire-popup'
      onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
    >
      <div className='relative modal-dialog w-[80%]'>
        <div className='modal-content p-4'>
          <div className='modal-body text-center'>
            <div className='modal-head border-0 bottom-0'>
              <Img
                className='w-[50px]'
                data-testid={'ICImg'}
                src={'/Resources/images/error.svg'}
                alt=''
                title=''
              />
            </div>
            <div className='flex flex-col p-3 breakLine'>
              <p>{t('translation:session_error_message')}</p>
              <ButtonLoader
                data-testid='errorBTN'
                className={'ta btn btn-secondary btn-sm mt-5'}
                type='button'
                isLoading={isLoading}
                onClick={handleConfirm}
              >
                {t('translation:confirm')}
              </ButtonLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return domReady ? ReactDOM.createPortal(element, document.getElementById('portal-modal')!) : null;
}
